import styled from "styled-components";

export const WarningMessageDefaultBox = styled.div`
    position: relative;
    height: 40px;
    background-color: black;
`;